import React from 'react';

function ContactStatTiles({ totalEvents, lifetimeSpend, averageTicket }) {
  const tiles = [
    { value: totalEvents, label: 'Total events' },
    { value: lifetimeSpend, label: 'Lifetime spend' },
    { value: averageTicket, label: 'Average ticket' },
  ].filter((tile) => tile.value !== null && tile.value !== undefined && tile.value !== '--');

  if (tiles.length === 0) return null;

  return (
    <div className="cdp-stat-grid">
      {tiles.map((tile) => (
        <div key={tile.label} className="cdp-card cdp-stat-tile">
          <div className="cdp-stat-value">{tile.value}</div>
          <div className="cdp-stat-label">{tile.label}</div>
        </div>
      ))}
    </div>
  );
}

export default ContactStatTiles;
